import React from "react";
import { twMerge } from "tailwind-merge";

export interface FeatureRadioProps {
  id: string;
  title: string;
  description: string;
  checkedContent?: React.ReactNode;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export const FeatureRadio: React.FC<FeatureRadioProps> = ({
  id,
  title,
  description,
  checked = false,
  checkedContent = null,
  onChange,
  disabled = false,
  className,
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      id={id}
      onClick={handleClick}
      disabled={disabled}
      className={twMerge(
        "w-full rounded-lg py-4 pl-4 pr-2 flex items-center gap-4 transition-colors duration-200",
        "border-2 border-chariot-stroke",
        checked &&
          "border-chariot-brand-primary bg-chariot-background-secondary",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      {/* Radio Circle */}
      <div
        className={twMerge(
          "relative shrink-0 size-5 rounded-full border-2 -mt-4",
          "flex items-center justify-center",
          checked ? "border-chariot-brand-primary" : "border-chariot-stroke"
        )}
      >
        <div
          className={twMerge(
            "size-3 rounded-full bg-chariot-brand-primary transition-all duration-200",
            checked ? "scale-100" : "scale-0"
          )}
        />
      </div>

      {/* Text content */}
      <div className="text-left">
        <p className="text-sm font-semibold text-chariot-text-primary">
          {title}
        </p>
        <p className="text-xs text-chariot-text-primary mt-0.5">
          {description}
        </p>
        {checked && checkedContent && (
          <div className="mt-4">{checkedContent}</div>
        )}
      </div>
    </button>
  );
};

export default FeatureRadio;
